import {
  REQUEST_PARTNERS,
  RECEIVE_PARTNERS
} from '../actions/constants';

export default function partners(
  state = {
    isFetching: false,
    partnerList: []
  }, action
) {
  switch (action.type) {
    case REQUEST_PARTNERS:
      return Object.assign({}, state, {
        isFetching: true
      })
    case RECEIVE_PARTNERS:
      return Object.assign({}, state, {
        isFetching: false,
        partnerList: action.partnerList
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/partnersReducer.js